import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PwdIcon from "../../assets/icons/pwd-icon.png";
import UserIcon from "../../assets/icons/user-icon.png";
import Logo from "../../assets/images/logo.png";
import { ChangeUserPasswordToken } from "../../redux/actions/account-action-types";
import { useParams } from "react-router-dom";
import { toastUtil, toastUtilText } from "../../utilities/toast-util";
import { xhrApiSendEmailConfirmation, xhrApiValidateEmailConfirmation } from "../../utilities/xhr-api";

const EmailConfirmationPage = () => {
  
	const dispatch = useDispatch();
	const history = useHistory();

  let { token: tokenId } = useParams();

	const [errors, setErrors] = React.useState("");
	const [user, setUser] = React.useState("");
	const [token, setToken] = React.useState("");

	React.useEffect(() => {
    setToken(tokenId ?? "");
	}, [tokenId]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if(token?.length > 0){
      var data = await xhrApiValidateEmailConfirmation({ email: user, token: token});
      toastUtil({ data, success: true });
      if(data?.result?.status === 'Success'){
        setTimeout(() => {
          history.push("/account/login");
        }, 1000);
      }
    }
    else{

    }

  };
  const sendConfirmEmail = async (e) => {
    e.preventDefault();
    var data = await xhrApiSendEmailConfirmation(user);
    toastUtil({ data, success: true });

  };

  return (
    <div>
      <header className="login-header">
        <nav className="navbar navbar-expand-md navbar-light bg-transparent justify-content-between">
          <span href="#" className="navbar-brand">
            <img src={Logo} alt="CoolBrand" className="loginLogoStyle"/>
          </span>
          {/* <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                  <span className="navbar-toggler-icon"></span>
              </button> */}
          <div className="navbar" id="navbarCollapse">
            <div className="navbar-nav">
              <a href="/account/login" className="nav-item nav-link highlight">
                Login
              </a>
              <a href="#" className="nav-item nav-link">
                Help
              </a>
            </div>
          </div>
        </nav>
      </header>
      {/*Begin Prospects*/}
      <div className="prospect-combo">
        <div className="container-fluid p-0">
          <div className="row m-0">
            <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 forgetpwd-left d-flex flex-column align-content-center justify-content-center">
              <div id="demo" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                  <div className="carousel-item active br-show pb-4">
                    <h2>
                      {" "}
                      Confirm
                      <br />
                      <span>Email</span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 form-element px-sm-5 d-flex flex-column align-content-center justify-content-center form-container">
              <h3 className="form-heading mb-4">Email confirmation</h3>
              <p className="form-subheading mb-4">
                Enter account email to confirm
              </p>
              <form onSubmit={(e)=> onSubmit(e)}>
                {  (
                  <div className="input-group mb-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      id="email"
                      name="email"
                      value={user}
                      onChange={(e) => { setUser(e?.target?.value) }}
                    />
                  </div>
                )}
                <div className="input-group mb-4">
                  <input
                  style={{ display: !(token?.length > 0) ? 'block' : 'none'}}
                    type="text"
                    className="form-control"
                    placeholder="Reset Code"
                    id="reset_code"
                    name="reset_code"
                    value={token}
                    onChange={(e) => { setToken(e?.target?.value) }}
                  />
                </div>
                {errors && 
                  <span style={{color:'red'}}>{errors}</span>
                }
                <button type="submit" className="btn btn-primary sign-fbtn " >
                  Confirm Email
                </button>
                
                <button type="button" className="btn btn-primary sign-fbtn " onClick={(e) => sendConfirmEmail(e)} >
                  Send code to email
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmationPage;
